import React, { useCallback } from 'react';
import clsx from 'clsx';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { makeStyles } from '@mui/styles';

import CustomButton from '../CustomButton';
import { BULK, SPLIT, TRANSFER } from '../../../constants/strings';
import palette from '../../styles/palette';
import { getBulkTestIdString } from '../../../models/parcel';
import useTransferToModalData from '../../../features/routeDetail/hooks/useTransferToModalData';

const useStyles = makeStyles(({ typography }) => ({
  container: {
    borderRadius: '0px 0px 10px 10px',
    marginLeft: 'auto',
    width: typography.pxToRem(256),
    background: palette.typography.black.inactive,
    position: 'absolute',
    bottom: typography.pxToRem(-57),
    right: 0,
  },
  corner: {
    height: typography.pxToRem(10),
    width: typography.pxToRem(10),

    left: typography.pxToRem(-10),
    overflow: 'hidden',
    position: 'absolute',

    '&:before': {
      height: typography.pxToRem(20),
      width: typography.pxToRem(20),
      position: 'absolute',
      right: typography.pxToRem(-20),
      top: typography.pxToRem(-20),
      margin: typography.pxToRem(20),
      borderRadius: '50%',
      boxShadow: '0 0 0 0.625rem rgba(0, 0, 0, .54)',
      content: 'close-quote',
    },
  },
  buttonsContainer: {
    margin: `${typography.pxToRem(7)} ${typography.pxToRem(
      18
    )} ${typography.pxToRem(10)} ${typography.pxToRem(30)}`,
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: typography.pxToRem(14),
    alignSelf: 'flex-end',
    color: palette.typography.white.solid,
  },
  checkbox: {
    color: palette.typography.white.solid,
  },
  disabled: {
    opacity: 0.38,
    pointerEvents: 'none',
  },
}));

const TableBottomOptions = ({
  onChangeBulk,
  isBulk,
  onSplitClick,
  isBulkDisabled,
  isSplitDisabled,
  isTransferDisabled,
}) => {
  const classes = useStyles();
  const { openTransferToModal } = useTransferToModalData();

  const onTransferClick = useCallback(() => {
    openTransferToModal({ isStopsSelected: false });
  }, [openTransferToModal]);

  return (
    <Box className={classes.container}>
      <Box className={classes.corner} />
      <Box className={classes.buttonsContainer}>
        <CustomButton
          title={SPLIT}
          onClick={onSplitClick}
          disabled={isSplitDisabled}
        />
        <CustomButton
          title={TRANSFER}
          onClick={onTransferClick}
          disabled={isTransferDisabled}
        />
        <FormControlLabel
          label={BULK}
          labelPlacement="start"
          className={clsx(classes.label, isBulkDisabled && classes.disabled)}
          control={
            <Checkbox
              onChange={onChangeBulk}
              checked={isBulk}
              color="default"
              disableRipple
              className={classes.checkbox}
              data-testid={getBulkTestIdString(isBulk, isBulkDisabled)}
            />
          }
        />
      </Box>
    </Box>
  );
};

export default TableBottomOptions;
